module.exports = __webpack_public_path__ + "static/media/debitArrow.fe7a974c.svg";